export const GenericServiceReducer = (actionName: string, initialState?: any) => {
  return (state = initialState ? initialState : {}, action: any) => {
    switch (action.type) {
      case `@@service/${actionName}_REQUEST`:
        return { ...state, isFetching: true };
      case `@@service/${actionName}_SUCCESS`:
        if (action.payload) {
          if (action.payload.pagination) return { ...state, isFetching: false, ...action.payload };

          if (action.payload.data) return action.payload.data;

          return action.payload;
        }

        return initialState;
      case `@@service/${actionName}_ERROR`:
        return { ...state, isFetching: false, error: action.error };
      case `@@service/${actionName}_RESET`:
        return { isFetching: false };
      default:
        return state;
    }
  };
};
